import { Stack, Typography } from '@mui/material';

type InfoField = {
  label: string;
  value: React.ReactNode;
};

type CustomerNavInfoFieldsProps = {
  infoFields: InfoField[];
};

export const CustomerNavInfoFields: React.FC<CustomerNavInfoFieldsProps> = ({ infoFields }) => (
  <Stack direction="column" sx={{
    alignItems: "center"
  }}>
    <Stack spacing={0.5}>
      {infoFields.map((field) => (
        <Stack key={field.label} direction="row" spacing={1}>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              width: 58
            }}>
            {field.label}:
          </Typography>
          <Typography variant="caption" sx={{
            color: "text.primary"
          }}>
            {field.value}
          </Typography>
        </Stack>
      ))}
    </Stack>
  </Stack>
);
